export class LayerDTO
{
    id : number;
    idLayerType : number;
    layerType : string;
    name : string;
    atributeDisplay : string;
    atributes : string;
    isVisible : boolean;
    icon: string;
    checked: boolean;
    isLoading: boolean;
    categoryId: number;
    itWorksAsVirtualLocation: boolean;
    isFilteredLayer: boolean;
    hasBeenFiltered: boolean;
    mapSourceId : string[];
}